/**
 * Step of MagicAlbumPanel : runs the placement (PhotoCurator + ChronologicalCreator through
 * placePhotosChronologically) with its progress, then closes the panel. data = { model, options, placing, placed }.
 * Waits for the photos still arriving before starting (see BaseStep).
 */
fx.ns("shared.screens.magic", class PlacingStep extends shared.screens.magic.BaseStep {

    constructor()
    {
        super();

        this._started = false;
    }

    create()
    {
        let box = new fx.components.Box();

        let circlesBox = new fx.components.Box("Person");
        this.personImage = new fx.components.Image({ data : fx.get("assets").splashPhoto, className : "image" });
        this.progress = new fx.components.RadialProgress({ thickness : 10, color : "#a2d7eb", backgroundColor : "#fff", style : "" });
        circlesBox.addChild(this.progress, { width : 240, height : 240, top : 10, left : "center" });
        circlesBox.addChild(this.personImage);
        box.addChild(circlesBox, { width : 260, height : 260, top : 0, left : "center" });

        this.title = new fx.components.Text({ text : fx.text("Un instant, je place vos photos..."), className : "title center" });
        box.addChild(this.title, { width : "100%", height : 40, top : 280, left : "center" });

        this.iconCheck = new fx.components.Image({ data : fx.get("assets").checkedIcon, className : "finished" });
        this.iconCheck.visibleAtStart = false;
        this.iconCheck.effect = "scale";
        box.addChild(this.iconCheck, { width : 60, height : 60, top : 330, left : "center" });

        this.addChild(box, { width : fx.browser.isDesktop ? 500 : "100%", height : 400, top : "center", left : "center" });
    }

    onReady()
    {
        this.data.placing = true;

        this.on("curate-progress", this._onProgress, fx.service("PhotoCurator"));

        if (this.photosPending)
            this.title.text = fx.text("Je récupère vos photos");

        this.whenPhotosReady(() => this._place());
    }

    _place()
    {
        if (this._started)
            return;

        this._started = true;
        this.title.text = fx.text("Un instant, je place vos photos...");

        let done = () => this._done();
        this.model.placePhotosChronologically(this.model.photos.active, this.data.options).then(done, done);
    }

    _onProgress(event)
    {
        let detail = event.detail || {};

        if (detail.step == "analysing")
        {
            this.progress.progress = Math.round(detail.progress * 0.8);
            this.title.text = fx.text("J'analyse vos photos ($%)", detail.progress);
        }
        else
        {
            this.progress.progress = 90;
            this.title.text = fx.text("Un instant, je place vos photos...");
        }
    }

    _done()
    {
        this.data.placing = false;
        this.data.placed = true;

        this.off("curate-progress", this._onProgress, fx.service("PhotoCurator"));

        // magic creation : the album, created empty and deleted so that an abandoned creation
        // never shows in the account, now exists ; its placement is not undoable. The creation is
        // over : the editor about to open works as usual (the automatic placement asks for its
        // confirmation again, the photo selection is the popup one, "Fermer" goes to the editor).
        if (fx.get("mode") == "creating-ia")
        {
            this.model.creation.deleted = 0;

            if (this.model.history)
                this.model.history.clear();

            fx.set("mode", "edition");
        }

        this.progress.progress = 100;
        this.iconCheck.show();
        this.title.text = fx.text("Votre album est prêt !");

        this.delay(this._close, 1500);
    }

    _close()
    {
        this.trigger("close");
    }
});
